import {useForm} from '@tanstack/react-form';
import React from 'react';
import {Button} from '~/components/Button';
import {RadioInput} from '~/components/Controls/Radio';
import {FormColumn, FormControls, FormRow, FormTitle, IntentText} from '~/components/Form';
import formStyle from '~/components/Form/index.module.scss';
import {IModalComponent, IModalComponentClose} from '~/components/Modal';
import {utcDay} from '~/lib/date';
import {Intent} from '~/lib/intent';

export interface IReplanSpendLimitsFormActions {
    setStatus: (status: string | undefined) => void;
}

export interface IReplanSpendLimitsValues {
    date: string;
}

export interface IReplanSpendLimitsModalProps {
    title: string;
    onSubmit: (values: IReplanSpendLimitsValues, formActions: IReplanSpendLimitsFormActions, close: IModalComponentClose) => void | Promise<void>;
}

export const ReplanSpendLimitsModal: IModalComponent<IReplanSpendLimitsModalProps> = props => {
    const closeModal = props.close ?? (() => undefined);
    const [status, setStatus] = React.useState<string>();
    const today = utcDay(0);
    const tomorrow = utcDay(1);

    const form = useForm({
        defaultValues: {date: today} as IReplanSpendLimitsValues,
        onSubmit: async ({value}) => {
            await Promise.resolve(props.onSubmit(value, {setStatus}, closeModal));
        }
    });

    return <form.Subscribe selector={state => state}>
        {state => (
            <form className={formStyle.form} onSubmit={event => {
                event.preventDefault();
                void form.handleSubmit();
            }}>
                <FormTitle>{props.title}</FormTitle>
                {status && <IntentText intent={Intent.DANGER}>{status}</IntentText>}
                <div className={formStyle.formBody}>
                    <FormRow>
                        <FormColumn>
                            <form.Field name='date'>
                                {fieldApi => (
                                    <>
                                        <RadioInput id='replan-date' value={fieldApi.state.value} optionValue={today} label={`Today (${today})`} onChange={fieldApi.handleChange}/>
                                        <RadioInput id='replan-date' value={fieldApi.state.value} optionValue={tomorrow} label={`Tomorrow (${tomorrow})`} onChange={fieldApi.handleChange}/>
                                    </>
                                )}
                            </form.Field>
                            <div>Limits are planned from past impressions, never lower than $100 an hour. A bidder without past impressions holds its fallback cap.</div>
                        </FormColumn>
                    </FormRow>
                </div>
                <FormControls>
                    <Button disabled={state.isSubmitting}
                        onClick={closeModal}
                    >Cancel</Button>
                    <Button type='submit'
                        disabled={state.isSubmitting || !state.canSubmit}
                        intent={Intent.PRIMARY}
                        rightIcon={state.isSubmitting && <i className='fa fa-spinner fa-spin'/>}
                    >Re-plan</Button>
                </FormControls>
            </form>
        )}
    </form.Subscribe>;
};
